import * as eventsApi from '../../api/eventsApi';
import {getAnswerAggregationStrategy} from '../../strategies/answerAggregationStrategies/answerAggregationStrategyFactory';

export const RECEIVE_FILTER_IN_RESULTS = 'RECEIVE_FILTER_IN_RESULTS';
export const REMOVE_FILTER_IN_RESULTS = 'REMOVE_FILTER_IN_RESULTS';
export const CLEAR_ALL_FILTERS_IN_RESULTS = 'CLEAR_ALL_FILTERS_IN_RESULTS';
export const RECEIVE_AGGREGATE_FILTERS = 'RECEIVE_AGGREGATE_FILTERS';

export const receiveFilter = filter => ({
    type: RECEIVE_FILTER_IN_RESULTS,
    filter
});

export const removeFilter = filter => ({
    type: REMOVE_FILTER_IN_RESULTS,
    filter
});

export const clearAllFilters = () => (dispatch, getState) => {
    const {
        app: {assessment},
        inline: {parentMetadata: inlineParentMetadata}
    } = getState();

    eventsApi.eventByType('clear-all-filters', assessment.id, {inlineParentMetadata});

    dispatch({
        type: CLEAR_ALL_FILTERS_IN_RESULTS
    });
};

export const receiveAggregateFilters = filters => ({
    type: RECEIVE_AGGREGATE_FILTERS,
    filters
});

export const aggregateFilters = () => (dispatch, getState) => {
    const filtersByPrompt = getState().session.selectedFilters.inAssessment;
    const {assessment} = getState().app;
    const allPrompts = getState().entities.prompts;

    const aggregationStrategy = getAnswerAggregationStrategy(assessment.type);
    const aggregated = aggregationStrategy(assessment, filtersByPrompt, allPrompts);

    dispatch(receiveAggregateFilters(aggregated));
};
